// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--sW4HO","Label":"Label--2wkfV","Submit":"Submit--2Z8kY","Icon":"Icon--3X7l4"};